<div *ngIf="!isLoginPage() && !isTokenLoginPage()"
  class="moov-toolbar-wrapper" [ngClass]="{ 'is-mobile-view': isMobileView }">
  <mat-toolbar class="moov-toolbar" [ngClass]="{ 'is-mobile-view': isMobileView }">
    
    @if(!isMobileView){
      <img class="systemLogo" src="../../assets/common/claro_logo.svg" />
      <span class="example-spacer"></span>
    }
    
    @if(user){
      <div class="moovMenu-userWelcome-container" [ngClass]="{ 'is-mobile-view': isMobileView }">
        <!-- in mobile view the alignment of the buttons are switched, so the text should always appear internally relative to the button -->
        <span *ngIf="!isMobileView"class="moovMenu-userWelcomeText" [ngClass]="{ 'is-mobile-view': isMobileView }">
          {{ "nav.welcome" | translate }} {{ user.firstName }}
        </span>
        <button mat-icon-button class="navIconWhite" aria-label="Example icon-button with a menu" [matMenuTriggerFor]="menu">
          <span class="material-symbols-outlined">person</span>
        </button>
        <span *ngIf="isMobileView"class="moovMenu-userWelcomeText" [ngClass]="{ 'is-mobile-view': isMobileView }">
          {{ "nav.welcome" | translate }} {{ user.firstName }}
        </span>


        <mat-menu #menu="matMenu" class="moovMenuContent" [ngClass]="{ 'is-mobile-view': isMobileView }">
          <button mat-menu-item [routerLink]="'/userProfile'">
            {{ "nav.userProfile" | translate }}
          </button>

          <button mat-menu-item (click)="logoutClicked()">
            {{ "nav.logout" | translate }}
          </button>
        </mat-menu>
      </div>

      @if(isMobileView){
        <span class="example-spacer"></span>

        <span class="moovMenu">
          <button mat-icon-button class="navIconWhite" aria-label="Example icon-button with a menu" (click)="toggleMenu()" >
            <mat-icon class="navIcon">menu</mat-icon>
          </button>
        </span>
      }
    }
  </mat-toolbar>
</div>
